import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import { Tooltip } from '@material-ui/core';
import { Info } from '@material-ui/icons';
import Button from 'components/CustomButtons/Button';
import Card from 'components/Card/Card';
import CardBody from 'components/Card/CardBody';
import FormTextInput from 'components/FormTextInput/FormTextInput';
import GridContainer from 'components/Grid/GridContainer';
import GridItem from 'components/Grid/GridItem';
import LabeledCheckbox from 'components/Checkbox/LabeledCheckbox';
import { post } from 'helpers/apiHelpers';
import makeStyles from '@material-ui/styles/makeStyles';

import ModuleNotLoaded from './ModuleNotLoaded';

const useStyles = makeStyles({
  infoIcon: {
    color: 'gray',
  },
});

const BitrixModule = ({ handleModuleUpdate, module }) => {
  const classes = useStyles();

  const { t } = useTranslation();

  const [isSyncing, setIsSyncing] = useState(false);

  if (!module) {
    return <ModuleNotLoaded moduleName="Bitrix" />;
  }

  const {
    enabled,
    webhookClient,
    webhookEvent,
    fieldEmailConsent,
    fieldSmsConsent,
    fieldPhoneConsent,
    fieldCreatedAt,
    fieldOrderId,
    fieldClientId,
    fieldClientEmail,
    fieldClientPhone,
  } = module;

  const updateModule = e => {
    handleModuleUpdate({
      ...module,
      [e.target.name]:
        e.target.type === 'checkbox' ? e.target.checked : e.target.value,
    });
  };

  return (
    <Card>
      <CardBody>
        <LabeledCheckbox
          name="enabled"
          label={t('brands.newBrandForm.useBitrix')}
          checked={enabled}
          onChange={updateModule}
        />
        <Button
          disabled={isSyncing}
          onClick={async () => {
            setIsSyncing(true);
            try {
              await post('/bitrix24/client-sync');
              toast.success(
                t('brands.newBrandForm.thulium.syncContacts.successMessage')
              );
              // eslint-disable-next-line no-empty -- FIXME
            } catch {
            } finally {
              setIsSyncing(false);
            }
          }}
        >
          {t('brands.newBrandForm.bitrix.syncContacts')}
        </Button>
        <Tooltip
          title={t('brands.newBrandForm.thulium.syncContacts.tooltip')}
          placement="top"
        >
          <Info className={classes.infoIcon} fontSize="small" />
        </Tooltip>
        <GridContainer>
          <GridItem sm={12}>
            <FormTextInput
              label={t('brands.newBrandForm.bitrix.webhookClient')}
              name="webhookClient"
              value={webhookClient}
              handleChange={updateModule}
              inputSize={12}
            />
            <FormTextInput
              label={t('brands.newBrandForm.bitrix.webhookEvent')}
              name="webhookEvent"
              value={webhookEvent}
              handleChange={updateModule}
              inputSize={12}
            />
          </GridItem>
          <GridItem sm={12}>
            <FormTextInput
              label={t('brands.newBrandForm.bitrix.fieldEmailConsent')}
              name="fieldEmailConsent"
              value={fieldEmailConsent}
              handleChange={updateModule}
              inputSize={12}
            />
            <FormTextInput
              label={t('brands.newBrandForm.bitrix.fieldSmsConsent')}
              name="fieldSmsConsent"
              value={fieldSmsConsent}
              handleChange={updateModule}
              inputSize={12}
            />
            <FormTextInput
              label={t('brands.newBrandForm.bitrix.fieldPhoneConsent')}
              name="fieldPhoneConsent"
              value={fieldPhoneConsent}
              handleChange={updateModule}
              inputSize={12}
            />
            <FormTextInput
              label={t('brands.newBrandForm.bitrix.fieldCreatedAt')}
              name="fieldCreatedAt"
              value={fieldCreatedAt}
              handleChange={updateModule}
              inputSize={12}
            />
            <FormTextInput
              label={t('brands.newBrandForm.bitrix.fieldOrderId')}
              name="fieldOrderId"
              value={fieldOrderId}
              handleChange={updateModule}
              inputSize={12}
            />
            <FormTextInput
              label={t('brands.newBrandForm.bitrix.fieldClientId')}
              name="fieldClientId"
              value={fieldClientId}
              handleChange={updateModule}
              inputSize={12}
            />
            <FormTextInput
              label={t('brands.newBrandForm.bitrix.fieldClientEmail')}
              name="fieldClientEmail"
              value={fieldClientEmail}
              handleChange={updateModule}
              inputSize={12}
            />
            <FormTextInput
              label={t('brands.newBrandForm.bitrix.fieldClientPhone')}
              name="fieldClientPhone"
              value={fieldClientPhone}
              handleChange={updateModule}
              inputSize={12}
            />
          </GridItem>
        </GridContainer>
      </CardBody>
    </Card>
  );
};

export default BitrixModule;
